import { Moon, Sun, Monitor } from 'lucide-react'
import { useTheme } from '@/hooks/useTheme'
import { cn } from '@/lib/utils'

interface ThemeToggleProps {
  className?: string
}

/**
 * 主题切换组件
 * 支持浅色/深色/跟随系统三种模式
 * 切换动画时长 300ms
 */
export function ThemeToggle({ className }: ThemeToggleProps) {
  const { theme, resolvedTheme, setTheme } = useTheme()

  const themeOptions = [
    { value: 'light' as const, label: '浅色', icon: Sun },
    { value: 'dark' as const, label: '深色', icon: Moon },
    { value: 'system' as const, label: '跟随系统', icon: Monitor },
  ] as const

  // 根据当前解析后的主题显示对应图标
  const _currentIcon =
    themeOptions.find(t => t.value === resolvedTheme)?.icon ?? Sun
  void _currentIcon

  return (
    <div className={cn('relative', className)}>
      <div className="flex items-center gap-1 rounded-lg bg-[#eceef7] p-1 dark:bg-[#222427]">
        {themeOptions.map(option => {
          const Icon = option.icon
          const isActive = theme === option.value

          return (
            <button
              key={option.value}
              onClick={() => setTheme(option.value)}
              className={cn(
                'flex h-8 w-8 items-center justify-center rounded-md transition-all duration-300',
                'hover:bg-[#dfe3ef] dark:hover:bg-[#2d2f33]',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500',
                isActive &&
                  'bg-white text-indigo-600 shadow-sm dark:bg-[#2d2f33] dark:text-indigo-400'
              )}
              title={option.label}
              aria-label={`切换到${option.label}主题`}
            >
              <Icon className="h-4 w-4" />
            </button>
          )
        })}
      </div>
    </div>
  )
}
